export const DEFAULT_LIBRARY_URLS = [
  "https://libraries.excalidraw.com/libraries/narhari-motivaras/aws-architecture-icons.excalidrawlib",
  "https://libraries.excalidraw.com/libraries/youritjang/azure-cloud-services.excalidrawlib",
  "https://libraries.excalidraw.com/libraries/clementbosc/gcp-icons.excalidrawlib",
  "https://libraries.excalidraw.com/libraries/dwelle/network-topology-icons.excalidrawlib",
  "https://libraries.excalidraw.com/libraries/dmitry-burnyshev/c4-architecture.excalidrawlib",
  "https://libraries.excalidraw.com/libraries/michelcaradec/cloud-design-patterns.excalidrawlib",
];

export const DEFAULT_LIBS_LOADED_KEY = "excalidraw-default-libs-loaded";
